/**
 * NjitTabbedContent behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Formstone.NoConflict();

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * hasScrollBar utility.
   *
   */

  (function($) {
    $.fn.hasHorizontalScrollBar = function() {
      return this.get(0).scrollWidth > this.width();
    }
  })(jQuery);
  (function($) {
    $.fn.hasVerticalScrollBar = function() {
      return this.get(0).scrollHeight > this.height();
    }
  })(jQuery);

  /**
   * TabbedContent behaviour.
   *
   */
  Drupal.NjitTabbedContent = function (container) {

    var thisContainer = container;

    /**
     * Prepare content to be converted to tabs.
     */
    this.prepareTabs = function () {
      reCalculateTab();
    };

    /**
     * Build tabs.
     */
    this.makeTabs = function () {
      var $container = $(thisContainer);

      $('.tab-control', $container).fsTabs({"mobileMaxWidth": '0'});
      $('.tab-control', $container).on("update.tabs", function(event) {
        var $tablink = $(event.currentTarget);
        window.location = $tablink.attr('data-tab-url');
        reCalculateTab(container);
      });
      // $('nav', this.$container).fsScrollbar({
      //   horizontal: true
      // });
    };

    this.setDefaultTab = function () {
      setDefaultTab();
    };

    var reCalculateTab = function (container) {
	    
      var $container = $(thisContainer);

      var container_id = Math.random().toString(16).slice(2);

      $container.attr({id: container_id + '-container'});
      var outer_width = 0;

      // Get the value for the attr 'data-tab-url'.
      var location = window.location;
      var tablink = location.hash.substring(location.hash.lastIndexOf('#')+1);
      var tabBaseUrl = location.href;
      if ($('[data-target="'+tablink+'"]').length >0) {
        var tabBaseUrl = tabBaseUrl.replace('#' + tablink, '');
      }

      $('.tab-control', $container).each(function () {
        var rel = $(this).data('target');
        $(this).attr('data-tab-url', tabBaseUrl + '#' + rel);
        var id = container_id + '-' + rel;
        $(this).attr({href: '#' + id,  "data-tabs-group":  container_id});
        var $item =  $('.tab-content[rel=' + rel + ']', $container);
        $item.attr('id', id);
        outer_width += ($(this).outerWidth() + 32); // Each item has left margin 32px and right margin 32px.
        outer_width += 1; // Added one more pixels to each tab item some tabs have decimal number width but JS can't get that decimal number.
      });
      outer_width -= 32; // First and last item don't have left and right margin.

      //$('.wide-load', $container).width(outer_width);
      if (outer_width > $container.outerWidth()) {
        $('.wide-load', $container).width(outer_width);
      }
      else {
        $('.wide-load', $container).css({width: 'auto'});
      }
      $('.bottom-line', $container).width(outer_width + 32 + 10);
    };

    var setDefaultTab = function () {
      // pick up has from url and see if it matches a tab
      var tablink = window.location.hash.substring(window.location.hash.lastIndexOf('#')+1);
      if ($('[data-target="'+tablink+'"]').length > 0) {
        $('[data-target="'+tablink+'"]').click();
        //$('div.fs-tabs-active').removeClass('fs-tabs-active');
        //$('a.fs-tabs-active').removeClass('fs-tabs-active');
        //
        //$('div[rel="'+tablink+'"]').addClass('fs-tabs-active');
        //$('a[data-target="'+tablink+'"]').addClass('fs-tabs-active');
      }
    }

    var that = this;
    this.init = function () {
      that.prepareTabs();
      that.makeTabs();
      that.setDefaultTab();
    }
  };

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.njitPhotoGallery.attach}}
   */
  Drupal.behaviors.NjitTabbedContent = {
    attach: function (context, settings) {

      // The tabbed content must be ready to be uses as tabbed content.
      // The default container selector is [data-tabbed-content="1"].
      $('[data-tabbed-content="1"]').each(function () {
        var NjitTabbedContent = new Drupal.NjitTabbedContent(this);
        fontSpy('Poppins', {
          success: function() {
            NjitTabbedContent.init();
          },
          failure: function() {
            NjitTabbedContent.init();
          }
        });
      });
      // add UI indicator if Tabs are scrolling
      var scrollShadeDebounced = _.debounce(scrollShade, 700);
      $(window).on('resize', scrollShadeDebounced);
      scrollShadeDebounced();
      function scrollShade() {
        if ($('.tabbed-nav .nav-scroll').length >= 1) {
          if ($('.tabbed-nav .nav-scroll').hasHorizontalScrollBar()) {
            $('.tabbed-nav').addClass('scrolling');
            $('.tabbed-nav.scrolling .scroll-shade').css("bottom",$('.tabbed-nav .nav-scroll').height());
          } else {
            $('.tabbed-nav').removeClass('scrolling');
          }
        }
      }

      $(".nav-scroll" ).scroll(function() {
        var maxScrollLeft = $('.nav-scroll').get(0).scrollWidth - $('.nav-scroll').get(0).clientWidth;
        if ($('.nav-scroll').scrollLeft() >= maxScrollLeft) {
          $('.tabbed-nav').removeClass('scrolling');
        } else {
          $('.tabbed-nav').addClass('scrolling');
        }
      });
    }
  }

})(Drupal, jQuery);
